export const DIALOG_COLUMNS = [
  'created',
  'from',
  'to',
  'hash',
  'type',
  'statusOriginal',
  'substatus',
  'comment',
  'netFee',
  'fee',
  'amount',
];

export const PAGE_COLUMNS = [
  'created',
  'from',
  'to',
  'hash',
  'type',
  'statusOriginal',
  'substatus',
  'coinId',
  'comment',
  'netFee',
  'fee',
  'amount',
];
